import React, {useEffect, useState} from 'react'
import 'react-credit-cards/es/styles-compiled.css'
import styles from './PaymentHeader.module.scss'
import { FormattedMessage, useIntl } from 'react-intl'
import { beautifyCurrency } from "../../curreny";

import Language from '../../assets/images/language.svg';
import {setLanguage} from '../../model/cardSagas/cardActions'
import {useDispatch, useSelector} from 'react-redux'
import {fixLanguageList} from '../../lang/lang'

export const PaymentHeader = props => {
  const {order, description, amount, currency} = props
  const dispatch = useDispatch()

  const card = useSelector(state => state.card)

  const languages = fixLanguageList(card?.formData?.payment_widget_data?.languages || [])
  const [open, setOpen] = useState(false)

  let showOrder = true

  try {
    showOrder = !JSON.parse(process.env.REACT_APP_HIDE_PAYMENT_ID)
  } catch (e) {

  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (event.target.closest('.language-change-wrapper') === null) {
        setOpen(false)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return (
    <div className={styles.header}>
      <div style={{display: 'flex', justifyContent: 'space-between', gap: '12px'}}>
        {showOrder && (
          <div className={styles.order}>
            {order && <FormattedMessage id="order" values={{order}}/>}
          </div>
        )}
        <div
          className="language-change-wrapper"
          style={{position: 'relative', maxHeight: 24, cursor: 'pointer'}}
          onClick={() => setOpen(!open)}
        >
          {(!!languages.length) && (
            <div
              style={{
                background: `url("${Language}") no-repeat center center`,
                height: 24,
                width: 24,
                padding: 0,
                backgroundSize: 'contain',
              }}
            />
          )}
          {open && (
            <div
              style={{
                position: "absolute",
                minWidth: "120px",
                top: "100%",
                right: 0,
                background: "#fff",
                borderRadius: "6px",
                marginTop: "4px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.3)"
              }}
            >
              {languages.map((lang) => (
                <div
                  key={lang}
                  onClick={() => {
                    dispatch(setLanguage(lang))
                    setOpen(false)
                  }}
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    color: "#000",
                    whiteSpace: 'nowrap',
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.background = "#eee")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.background = "transparent")
                  }
                >
                  <FormattedMessage id={`language.${lang}`} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {description && <div className={styles.description}>{description}</div>}
      {(amount && currency) && (
        <div className={styles.amount}>
          <FormattedMessage id="amount" values={{amount}}/>
          {" "}
          <span className={styles.currency}>{beautifyCurrency(currency)}</span>
        </div>
      )}
    </div>
  )
}
